import { useState } from "react";
import SurveyForm from "./components/SurveyForm";
import LoadingScreen from "./components/LoadingScreen";
import SubmissionResult from "./components/SubmissionResult";
import ConnectionStatus from "./components/ConnectionStatus";
import { useSurveyModel } from "./hooks/useSurveyModel";
import { useSurveySubmission } from "./hooks/useSurveySubmission";
import { useNetworkStatus } from "./hooks/useNetworkStatus";
import { downloadPDF } from "./utils/pdfUtils";
import ErrorScreen from "./components/ErrorScreen"; // Import the ErrorScreen component
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const [pdfData, setPdfData] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [onSubmitting, setOnSubmitting] = useState(false);
  const [error, setError] = useState(null); // Add error state

  const { isOnline } = useNetworkStatus();

  const handleOnCompleting = useSurveySubmission(
    setPdfData,
    setIsSubmitted,
    setOnSubmitting,
    setError // Pass the setError function to the hook
  );
  const surveyModel = useSurveyModel(handleOnCompleting);

  return (
    <ErrorBoundary>
      <ConnectionStatus isOnline={isOnline} />
      <div data-testid="app">
        {!isSubmitted && !onSubmitting && !error && (
          <SurveyForm surveyModel={surveyModel} isOnline={isOnline} />
        )}
        {!isSubmitted && onSubmitting && !error && <LoadingScreen />}
        {isSubmitted && !onSubmitting && !error && (
          <SubmissionResult
            onDownloadPDF={() => downloadPDF(pdfData)}
            pdfData={pdfData}
            isOnline={isOnline}
          />
        )}
        {/* Render ErrorScreen when there's an error */}
        {error && <ErrorScreen error={error} />}{" "}
      </div>
    </ErrorBoundary>
  );
}

export default App;
